import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const NAV_LINKS = [{
  label: 'El Problema',
  href: '#lead'
}, {
  label: 'El Mecanismo',
  href: '#mechanism'
}, {
  label: 'Qué Incluye',
  href: '#includes'
}, {
  label: 'Testimonios',
  href: '#testimonials'
}, {
  label: 'Para Quién',
  href: '#for-whom'
}];
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const closeMenu = () => setIsMobileMenuOpen(false);
  return <header className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${isScrolled ? 'bg-charcoal/95 backdrop-blur-md py-4 shadow-lg border-b border-charcoal-light' : 'bg-transparent py-6'}`} data-id="element-139">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-140">
        <a href="#hero" className="text-2xl font-heading font-bold tracking-widest text-offwhite hover:text-sand transition-colors" data-id="element-141">
          RESET <span className="text-sand" data-id="element-142">7D</span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-143">
          {NAV_LINKS.map(link => <a key={link.href} href={link.href} className="text-sm font-medium text-offwhite-dim hover:text-sand transition-colors uppercase tracking-wider" data-id="element-144">
              {link.label}
            </a>)}
          <a href="https://wa.link/we351n" target="_blank" rel="noopener noreferrer" className="px-5 py-2.5 bg-sand/10 text-sand border border-sand/30 hover:bg-sand hover:text-charcoal-dark transition-all duration-300 rounded-sm font-heading text-sm font-bold uppercase tracking-wider" data-id="element-145">
            Unirse
          </a>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-offwhite hover:text-sand transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-146">
          {isMobileMenuOpen ? <XIcon className="w-7 h-7" data-id="element-147" /> : <MenuIcon className="w-7 h-7" data-id="element-148" />}
        </button>
      </div>

      {/* Mobile Accordion Menu */}
      <AnimatePresence data-id="element-149">
        {isMobileMenuOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="md:hidden overflow-hidden bg-charcoal-dark border-b border-charcoal-light" data-id="element-150">
            <nav className="flex flex-col px-6 py-4 space-y-4" data-id="element-151">
              {NAV_LINKS.map(link => <a key={link.href} href={link.href} onClick={closeMenu} className="text-base font-medium text-offwhite-dim hover:text-sand transition-colors uppercase tracking-wider py-2 border-b border-charcoal-light/50" data-id="element-152">
                  {link.label}
                </a>)}
              <a href="https://wa.link/we351n" target="_blank" rel="noopener noreferrer" onClick={closeMenu} className="mt-4 text-center px-5 py-3 bg-sand text-charcoal-dark font-heading font-bold uppercase tracking-wider rounded-sm" data-id="element-153">
                RESET → $47 (quedan 5 cupos)
              </a>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}